import { usePatientStore } from "../../../hooks";

export const PatientSurgeryResultsTable = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,
  } = usePatientStore();

  const {
    track = null,
    dasiScore = null,
    mets = null,
    cRisk = null,
    asa = null,
  } = patientSurgery.data;

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//

  return (
    <div className="table-responsive shadow border-0">
      <table className="table">
        <thead className="table-primary">
          <tr>
            <th className="border-bottom p-3">Indicador</th>
            <th className="border-bottom p-3">Resultado</th>
          </tr>
        </thead>
        <tbody>
          {track !== null && (
            <tr>
              <td className="p-3">Riesgo</td>
              <td className="p-3">{track}</td>
            </tr>
          )}
          {dasiScore !== null && (
            <tr>
              <td className="p-3">Dasi Score</td>
              <td className="p-3">{dasiScore}</td>
            </tr>
          )}
          {mets !== null && (
            <tr>
              <td className="p-3">Mets</td>
              <td className="p-3">{mets}</td>
            </tr>
          )}
          {cRisk !== null && (
            <tr>
              <td className="p-3">Riesgo cardiovascular</td>
              <td className="p-3">{cRisk}</td>
            </tr>
          )}
          {asa !== null && (
            <tr>
              <td className="p-3">Clasificación ASA</td>
              <td className="p-3">{asa}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
